import React from "react";
import classnames from "classnames";
import isEqual from "lodash/isEqual";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
//icons
import ActionPrint from "@material-ui/icons/Print";
// jazasoft
import { PageHeader, PageFooter, BackButton, showNotification } from "jazasoft";
// local
import OrderDetails from "../../OrderDetails";
import MicroController from "./MicroController";
//helpers
// import { printCutPlan } from "../../cutplan/cutPlanHelper";
import { MicroReportId } from "../../../constants";
import { OState } from "../../../utils/types";

const styles = theme => ({
  root: {},
  container: {
    margin: "1.5em",
    padding: 0
  },
  marginVertical: {
    margin: "1.5em 0"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    margin: "1.5em"
  }
});

class CutPlanReportView extends React.Component {
  state = {
    printing: false
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.order, nextProps.order)) {
      const order = nextProps.order;
      const fabricIds =
        order && order.flowInfoList.flatMap(part => part.ledgerList || []).map(ledger => ledger.fabricId);
      this.props.updateFabrics(fabricIds);
    }
  }

  onPrint = orderFlow => () => {
    // const { order, fabrics } = this.props;
    if (orderFlow.stateValue > OState.MAIN_CUTPLAN_COMPLETED.stateValue) {
      // printCutPlan({ order, orderFlow, stageTabIdx: orderFlow.stage === "Stage 2" ? 1 : 0, fabrics });
    } else {
      this.props.dispatch(showNotification("Planning not done yet."));
    }
  };

  render() {
    const { classes, order, basePath, i18nKey, resource, orderFlowMap } = this.props;

    const orderFlowList = orderFlowMap ? Object.keys(orderFlowMap).map(key => orderFlowMap[key]) : [];

    return (
      <div className={classnames(classes.root)}>
        <PageHeader title="Cut Plan Report" />

        {order && Object.keys(order).length > 0 && (
          <div id="container" className={classes.container}>
            {/*Order Details */}
            <OrderDetails
              id="order-details"
              className={classes.border}
              record={order}
              basePath={basePath}
              resource={resource}
              i18nKey={i18nKey}
            />
            {orderFlowList.length > 0 && (
              <Paper className={classes.marginVertical} square>
                <List>
                  {orderFlowList
                    .flatMap(oc =>
                      oc.reGenerated
                        ? [
                            { ...oc, stage: "Stage 1" },
                            { ...oc, stage: "Stage 2" }
                          ]
                        : [oc]
                    )
                    .map((oc, idx) => (
                      <ListItem key={idx}>
                        <ListItemText>{`${oc.product?.name}, ${oc.styles}, ${oc.colors}, ${oc.part}, Lot${oc.lot} ${
                          oc.stage ? `,${oc.stage}` : ""
                        }`}</ListItemText>
                        <ListItemSecondaryAction>
                          <Button edge="end" aria-label="Print" color="primary" onClick={this.onPrint(oc)}>
                            <ActionPrint style={{ marginRight: 4 }} />
                            Print
                          </Button>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                </List>
              </Paper>
            )}

            {orderFlowList.length === 0 && (
              <div className={classes.displayCenter}>
                <Typography color="secondary" variant="h6">
                  Report not available
                </Typography>
              </div>
            )}

            <PageFooter>
              <BackButton variant="contained" color="default" />
            </PageFooter>
          </div>
        )}
      </div>
    );
  }
}

const StyledCutPlanReport = withStyles(styles)(CutPlanReportView);

const CutPlanReport = props => (
  <MicroController requestConfig={{ params: { page: "CutPlan" } }} microReportId={MicroReportId.CUT_PLAN} {...props}>
    {controllerProps => <StyledCutPlanReport {...props} {...controllerProps} />}
  </MicroController>
);

export default CutPlanReport;
